/**********************************************************************************************
* OntarioTECK VBA Developers
* Developed by Gustavo Miller
* Date created : 2026-06-02 11:26:34.340
*
* Location: D:\Acorns and Oaks (AAO)\AAO\wwwroot\
* Filename: js\contact.js
**********************************************************************************************/
import { implementPopover, ConfigurePopover } from "./utilities/popUtils.js"
import { initTinyMce } from './api/tinyinitializer.js';

declare const tinymce: any;

document.addEventListener("DOMContentLoaded", async (event) => {
    console.info(`Acorns and Oaks Fire up!`);

    await implementPopover("Index");
    console.log(`Implement Popover`);

    ConfigurePopover(5000);
    console.log(`Configure Popover`);

    console.log(`Initialize TinyMCE`);
    await initTinyMce("#message");

    console.log(`Load TinyMCE`);
    const editor = tinymce.get("message");
});